export default "__VITE_ASSET__ChP0ADra__"